import { helper } from '@ember/component/helper';

export const itemAtIndex = (params) => params[0][params[1]];

export default helper(itemAtIndex);
